package one.healthium.settings.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.white

@Composable
fun SettingsItem(
    label: String,
    trailing: @Composable () -> Unit = { },
    onClick: () -> Unit = {},
    textColor: Color = AppTheme.colors.text100,
) {
    Box(
        modifier = Modifier
            .background(white)
            .clickable { onClick() },
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .defaultMinSize(minHeight = 48.dp)
                .padding(horizontal = 12.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Text(
                modifier = Modifier.weight(1f),
                text = label,
                style = AppTheme.textStyles.secondary_17_400,
                color = textColor,
            )
            Spacer(Modifier.width(8.dp))
            trailing()
        }
    }
}